import { render, staticRenderFns } from "./FilterDetails.vue?vue&type=template&id=b4130184&scoped=true&"
import script from "./FilterDetails.vue?vue&type=script&lang=js&"
export * from "./FilterDetails.vue?vue&type=script&lang=js&"
import style0 from "./FilterDetails.vue?vue&type=style&index=0&id=b4130184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4130184",
  null
  
)

component.options.__file = "www/vues/client/filters/FilterDetails.vue"
export default component.exports